function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none !important;stroke:#2B2B2B;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M14.6,0.8c3.4,0,6.2,2.8,6.2,6.2l0,0 M16.1,14.6v12.3c0,1.7-1.4,3.1-3.1,3.1c0,0,0,0,0,0H3.8 c-1.7,0-3.1-1.4-3.1-3.1c0,0,0,0,0,0V8.4c0-1.7,1.4-3.1,3.1-3.1c0,0,0,0,0,0h4.6 M13.1,5.4c1.7,0,3.1,1.4,3.1,3.1c0,0,0,0,0,0  M6.7,26.1h3.4"
});

var SvgMobile = function SvgMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.5 30.7",
    style: {
      enableBackground: "new 0 0 21.5 30.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile.624baa52.svg";
export { ForwardRef as ReactComponent };